define((require) => {
    "use strict";

    const $                                     = require("jquery");
    const SalesforceCommerceWidgetSettingsView  = require("ui/experience/widgets/salesforceCommerceWidget/settings/view/SalesforceCommerceWidgetSettingsView");
    const SalesforceCommerceQuickViewSettings   = require("ui/experience/widgets/salesforceCommerceWidget/settings/view/SalesforceCommerceQuickViewSettings");
    const Scene7IntegrationView                 = require("editor/ui/settings/integrations/Scene7IntegrationView");
    const ImprovedView                          = require("editor/zbone/ImprovedView");
    const template                              = require("editor/ui/settings/integrations/addOns/AddOnsView.tpl");
    const ShopifyStoreSettings                  = require("../../ShopifyStoreSettings").default;
    const ReactBridge                           = require("backbone.react-bridge");
    const Configuration                         = require("shared/services/Configuration");
    const LoggedInUserState                     = require("shared/ui/user/LoggedInUserState");
    const Storage                               = require("shared/services/Storage");

    return ImprovedView.extend({

        template,

        templateHelpers() {
            return {
                isScene7Enabled: this._isScene7Enabled,
                isShopifyMenuEnabled: this._isShopifyMenuEnabled
            };
        },

        ui: {
            tabs: ".tab",
            tabPanes: ".tab-pane"
        },

        regions: {
            widget: ".widget",
            quickView: ".quick-view-action",
            adobeScene7: ".adobe-scene-7",
            shopifySettings: ".shopify-store"
        },

        events: {
            "click @ui.tabs": "_tabClickHandler"
        },

        initialize() {
            this._isScene7Enabled = this.options.integrationsCollection && this.options.integrationsCollection.isScene7IntegrationEnabled();
            this._isShopifyMenuEnabled = this._getConnectSettings();
        },

        onRender() {
            // create the model class.
            this.widget.show(new SalesforceCommerceWidgetSettingsView({model: this.model}));
            this.quickView.show(new SalesforceCommerceQuickViewSettings());
            if (this._isScene7Enabled) {
                this.adobeScene7.show(new Scene7IntegrationView({
                    integrationsCollection: this.options.integrationsCollection,
                    isManager: this.options.isManager
                }));
            }
            if (this._isShopifyMenuEnabled) {
                this.shopifySettings.show(this._setShopifySetting());
            }
        },

        _tabClickHandler(event) {
            this._showTab(event.target.getAttribute("data-tab-name"));
        },

        _showTab(tabName) {
            this.ui.tabs.each((index, element) =>  {
                $(element).toggleClass("active", element.getAttribute("data-tab-name") === tabName);
            });

            this.ui.tabPanes.each((index, element) => {
                $(element).toggleClass("active", element.getAttribute("data-tab-pane") === tabName);
            });
        },

        _setShopifySetting() {
            return ReactBridge.viewFromComponent(ShopifyStoreSettings);
        },

        beforeNavigate() {
            return this.widget.currentView.beforeNavigate();
        },

        _getConnectSettings() {
            const companyId = LoggedInUserState.attributes.company.id,
                endpointUrl = `${Configuration.creatorSettingApiBaseUrl}/v1/settings/${companyId}`,
                token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
                bearerToken = `Bearer ${token}`,
                settingName = "connect",
                path = `${endpointUrl}?name=${settingName}`;
            let isShopifyMenuEnabled = false;

            $.ajax({
                async: false,
                url: path,
                method: "GET",
                headers: {
                    Authorization: bearerToken
                },
                success: function(data) {
                    Storage.Local.update(Storage.Keys.CREATOR_CONNECT, data.connect);
                    isShopifyMenuEnabled = data.connect.enabled && data.connect.ipd.enabled;
                },
                error: function() {
                    isShopifyMenuEnabled = false;
                }
            });

            return isShopifyMenuEnabled;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/addOns/AddOnsView.js